import React, { useState, useEffect, useRef } from 'react';
import { MetricCard, useFormatter } from 'src/mtska-frontend-app-component';
import { CircularProgress, Typography } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';

const KPIGoalSet = ({ dataProviderName, filters: defaultFilters }) => {

    const { t } = useTranslation();
    const { formatNumber } = useFormatter();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [goalOverview, setGoalOverview] = useState();
    const [localDrawable, setLocalDrawable] = useState();

    const { item, loadOne, loading } = useDataProvider('statisticsviews/goal');
    const lastFiltersRef = useRef();

    useEffect(() => {
        const stringified = JSON.stringify(filterModel);
        if (lastFiltersRef.current !== stringified && !loading) {
            lastFiltersRef.current = stringified;
            loadOne('overview', { filters: filterModel });
        }
    }, [filterModel]);

    useEffect(() => {
        if (loading || !item || item.length == 0) {
            return
        }

        setGoalOverview(item.data);
        setLocalDrawable(true);
    }, [loading])

    const renderRow = (yearData) => {
        if (!yearData) return null;

        return (
            <div className="mtska-metrics-row" key={yearData._id}>


                {/* 
                <Typography level="h4" className="mtska-metrics-year">{yearData._id}</Typography>
                <div className="mtska-metrics-section">
                    <Typography level="title-md" className="mtska-metrics-section-title">{t('goal.total')}</Typography>
                    <div className="mtska-metrics-grid">
                        <MetricCard label={t('goal.lead')} value={formatNumber(yearData.totalLeadGoal, 0)} />
                        <MetricCard label={t('goal.proposal')} value={formatNumber(yearData.totalProposalGoal, 0)} />
                        <MetricCard label={t('goal.win')} value={formatNumber(yearData.totalWinGoal, 0)} />
                    </div>
                </div>

                <div className="mtska-metrics-section">
                    <Typography level="title-md" className="mtska-metrics-section-title">{t('goal.daily')}</Typography>
                    <div className="mtska-metrics-grid">
                        <MetricCard label={t('goal.lead')} value={formatNumber(yearData.dailyLeadGoal, 2)} />
                        <MetricCard label={t('goal.proposal')} value={formatNumber(yearData.dailyProposalGoal, 2)} />
                        <MetricCard label={t('goal.win')} value={formatNumber(yearData.dailyWinGoal, 2)} />
                    </div>
                </div> 
                

                <div className="mtska-metrics-section">
                    <Typography level="title-md" className="mtska-metrics-section-title">{t('goal.period')}</Typography>
                    <div className="mtska-metrics-grid">
                        <MetricCard label={t('goal.lead')} value={formatNumber(yearData.periodLeadGoal, 0)} />
                        <MetricCard label={t('goal.proposal')} value={formatNumber(yearData.periodProposalGoal, 0)} />
                        <MetricCard label={t('goal.win')} value={formatNumber(yearData.periodWinGoal, 0)} />
                    </div>
                </div>
                */}


                <Typography level="h4" className="mtska-metrics-section-title">{t('goal.period')}</Typography>
                <div className="mtska-metrics-grid">
                    <MetricCard label={t('goal.lead')} value={formatNumber(yearData.periodLeadGoal, 0)} />
                    <MetricCard label={t('goal.proposal')} value={formatNumber(yearData.periodProposalGoal, 0)} />
                    <MetricCard label={t('goal.win')} value={formatNumber(yearData.periodWinGoal, 0)} />
                </div>
            </div>
        );
    };

    return (localDrawable && goalOverview ?
        <div className="mtska-metrics-wrapper">
            {Array.isArray(goalOverview) && goalOverview.map(yearData => renderRow(yearData))}
        </div>
        :
        <CircularProgress />
    )
}

export default KPIGoalSet;